import isNull from 'lodash/isNull'
import { fetchGET } from '../api/fetchers'
import homeModule from '../modules/home'
import productModule from '../modules/product'
import customerModule from '../modules/customer'
import { accessToken, localStorage, customerProfile } from '../utils'

const HOST = process.env.REACT_APP_HOST || ''
const ShoppingStorage = process.env.REACT_APP_SHPOPPING_STORAGE || 'SPC-SHOPPING-LIST'

const pushHistoryStateAction = ({ history }) => {
  return async (dispatch, getState) => {
    const historyState = getState().home.historyState
    historyState.push(history)
    dispatch(homeModule.updateHistoryState({
      data: [...historyState]
    }))
  }
}

const popHistoryStateAction = () => {
  return async (dispatch, getState) => {
    const historyState = getState().home.historyState
    historyState.pop()
    dispatch(homeModule.updateHistoryState({
      data: [...historyState]
    }))
  }
}

const updateHistoryStateAction = ({ historyState }) => {
  return async (dispatch) => {
    dispatch(homeModule.updateHistoryState({
      data: [...historyState]
    }))
  }
}

const getAccessTokenAction = () => {
  return async () => {
    const response = await fetchGET({
      useMock: false,
      jsonMock: '',
      url: `${HOST}/login-api/spc_login/user/getToken`,
      data: {}
    })

    accessToken.set(response?.data?.result?.token)
  }
}

const getShoppingListFromStorageAction = () => {
  return async (dispatch) => {
    const cartList = localStorage.get(ShoppingStorage)
    const shoppingCart = !isNull(cartList) ? JSON.parse(cartList) : []

    dispatch(productModule.setData({
      data: {
        'shoppingCart': shoppingCart
      }
    }))
  }
}

const getCustomerProfileFromStorageAction = () => {
  return async dispatch => {
    const profile = customerProfile.getProfile()

    dispatch(customerModule.setData({
      data: {
        'customerProfile': profile
      }
    }))
  }
}

export {
  getAccessTokenAction,
  getShoppingListFromStorageAction,
  getCustomerProfileFromStorageAction,
  pushHistoryStateAction,
  popHistoryStateAction,
  updateHistoryStateAction
}
